export function hasMarkup(value) {
    return /(<([^>]+)>)/i.test(value);
}
